import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.listComponent), { config: _ctx.config }, {
    default: _withCtx(() => [
      _createVNode(_component_Button, {
        label: "insights",
        icon: "pi pi-chart-line",
        class: "insights-list-button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/users/insights')))
      })
    ]),
    _: 1
  }, 8, ["config"]))
}